import { useState, useEffect } from 'react';
import { BpmService } from '../../../../core/services/BpmService';



interface Props {
    idSelector: number;
    onChange: any;
    titulo: string;
    idLnFunctionalID: number;
}

export const SelectorRol = ({ titulo, idSelector, onChange, idLnFunctionalID }: Props) => {




    const service = new BpmService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(0);

    useEffect(() => {
        getLista();
        if (idSelector > 0) {
            setID(idSelector)
        }
    }, [idSelector, idLnFunctionalID])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        service.getBusinessRoleCatalog(idLnFunctionalID).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
               //console.log("DataAcces", lista);
            }
        );
    }

    return (
        <>
            <label>{titulo}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={0}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <>
                                <option key={index} value={item.DataBeanProperties.IDBusinessRole} >
                                    {item.DataBeanProperties.Name}
                                </option>
                            </>)
                    })
                }
            </select>
        </>
    )
}